import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';
import { PushDialogComponent } from './dialogs/push-dialog/push-dialog.component';
import { PushService } from '../services/push.service';
import { Push } from '../models/push';
import { EventService } from '../services/event.service';
import { Event } from '../models/event';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-push',
  templateUrl: './push.component.html',
  styleUrls: ['./push.component.scss'],
  entryComponents: [
    PushDialogComponent,
    ConfirmComponent
  ]
})

export class PushComponent implements OnInit {

  private sub: Subscription;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'date', 'title', 'target','sent', 'edit', 'delete'];
  public selectEventForm: FormGroup;
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private _pushService: PushService,
    private _eventService: EventService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private fb: FormBuilder) {

  }
  
  ngOnInit() {
    this.loadPushes()
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }


  compareNames(a, b) {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  }

  loadPushes() {
    this.sub = this._pushService.select()
      .subscribe((result) => {

        let array = result.map(item => {

          let push = new Push();
          push.id = item.payload.doc.id;
          push.title = item.payload.doc.data().title;
          push.text = item.payload.doc.data().text;
          push.url = item.payload.doc.data().url;
          push.push_type = item.payload.doc.data().push_type;
          push.event_id = item.payload.doc.data().event_id;
          push.list = item.payload.doc.data().list;
          push.sent = item.payload.doc.data().sent;

          push.date_create = item.payload.doc.data().date_create;
          push.time_to_send = item.payload.doc.data().time_to_send;

          if (item.payload.doc.data().date_to_send)
            push.date_to_send = item.payload.doc.data().date_to_send;

          return push;
        });

        array.sort(this.compareNames)

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.paginator = this.paginator;
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(push) {

    let pushData: Push = new Push();

    if (push) {
      pushData = push;
    } else {
      pushData = new Push();
    }

    this.dialog.open(PushDialogComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      data: pushData
    });

  }

  delete(element) {
    let push_id = element.id
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.title + "<br><br>Excluir este push?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._pushService.delete(push_id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete push error: " + error.message) }
          )
          .finally(
            () => this.dialog.closeAll()
          )
      }
    })
  }

}
